export function applyThemeVariables(colors) {
    if (!colors) {
        return;
    }

    const root = document.documentElement;

    if (colors.primary) {
        root.style.setProperty("--app-primary", colors.primary);
    }

    if (colors.success) {
        root.style.setProperty("--app-success", colors.success);
    }
}